import axios from 'axios'
import { message } from 'ant-design-vue'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  crossDomain: true,
  timeout: 600000 // request timeout
})

service.interceptors.request.use(
  config => {
    if (process.env['NODE_ENV'] === 'development') {
      // 针对本地测试环境将 token 从 cookie 中提取出来放至 header 中以解决跨域问题
      const token = document.cookie.replace(/(?:(?:^|.*;\s*)TEST_STAR_JWT\s*=\s*([^;]*).*$)|^.*$/, '$1')
      config.headers['Jwtauthorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.headers['content-type'] === 'application/json') {
      // 针对 JSON 交互统一处理通用返回类型
      const responseBody = response.data
      if (responseBody.code !== 0) {
        const errorMessage = responseBody.message
        message.error({ content: errorMessage, type: 'error', duration: 5 })
        return Promise.reject(new Error(errorMessage))
      }
      return responseBody
    }
    return response
  },
  error => {
    if (error.response) {
      // 请求已发但服务器返回的状态码不在 2xx 范围内
      const response = error.response
      switch (response.status) {
        case 401: {
          const REDIRECT_KEY = 'NOTICE_401_REDIRECT_TS'
          const lastRedirect = sessionStorage.getItem(REDIRECT_KEY)
          const now = Date.now()
          if (lastRedirect && now - parseInt(lastRedirect) < 5000) {
            sessionStorage.removeItem(REDIRECT_KEY)
            window.location.replace('/Dashboard')
            break
          }
          sessionStorage.setItem(REDIRECT_KEY, now.toString())
          const url = `${process.env.VUE_APP_PASSPORT_API}/login?service=${encodeURIComponent(location.href)}`
          window.open(url, '_self')
          break
        }
        case 403: {
          const errorMessage = '权限不足'
          message.error({ content: errorMessage, type: 'error', duration: 5 })
          break
        }
        case 404: {
          const errorMessage = '资源不存在'
          message.error({ content: errorMessage, type: 'error', duration: 5 })
          break
        }
        default: {
          break
        }
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      const errorMessage = '服务器未响应'
      message.error({ content: errorMessage, type: 'error', duration: 5 })
    } else {
      // 发出请求时发生错误
      const errorMessage = '网络错误'
      message.error({ content: errorMessage, type: 'error', duration: 5 })
    }
    console.log(error)
    return Promise.reject(error)
  }
)
export default service
